export default "__VITE_ASSET__4vFoybPy__"